import React, { FC } from 'react';
import { ArrowRightAlt } from '@mui/icons-material';

interface Props {
  value?: string;
  newValue?: string;
}

const EditableValue: FC<Props> = ({ newValue, value }) => {
  const changed = newValue && newValue !== value;
  return <span>{newValue || value}</span>;
};

export default EditableValue;
